<section>
	<div class="w-full flex flex-col justify-center items-center mb-3">
		<div class="fb-thank-you ">
			<span class="material-symbols-outlined">
				check_circle
			</span>
		</div>
		<h1 class="text-3xl md:text-5xl my-3 text-center">Thank you for shopping with us!</h1>
		<p class=" px-4 text-justify md:text-center py-2 text-sm md:text-base">We are getting started on your order right away, and you will receive an order confirmation email shortly.</p>
		<p class="max-w-screen-md px-4 text-justify md:text-center mb-5 text-sm md:text-base">Your purchase not only brings beautiful, handcrafted fabric into your life but also <span class="font-bold">empowers an artisan</span> from a remote Indian village. By choosing our fabric, you help sustain their craft, support their livelihood, and connect their creation to the world.
			We appreciate your support and look forward to serving you again!</p>
		<a class="text-center text-[#6c5b48] underline cursor-pointer" routerLink="/profile/order">Track and manage your orders</a>
		<p class="max-w-screen-lg w-full px-4 h-0.5 bg-[#6c5b48] mt-5"></p>
	</div>
	<fb-profile-order (conversionData)="sendConversionInfo($event)" [showHeader]="false"></fb-profile-order>
</section>
